<template>
  <v-btn
    icon
    variant="text"
    size="small"
    color="primary"
    class="settings-header-button"
    aria-label="Settings"
    to="/settings"
  >
    <v-icon size="22">mdi-cog</v-icon>
  </v-btn>
</template>

<script setup lang="ts">
// Gear = entry to the unified Settings (/settings).
</script>

<style scoped>
.settings-header-button {
  transition: transform 0.2s ease;
}

.settings-header-button:hover {
  transform: scale(1.1);
}
</style>

